import { CheckoutInfoResponse } from "../../../types/CheckoutInfoResponse";

type IframeTypeProps = {
  getCheckoutInfoData: CheckoutInfoResponse;
};

const IdNavigationMode = ({ getCheckoutInfoData }: IframeTypeProps) => {
  const url = getCheckoutInfoData.qrcodeUrl;

  return (
    <div className={"videobox"} style={{ height: "80dvh" }}>
      <iframe src={url} allowFullScreen={true} />
    </div>
  );
};

export default IdNavigationMode;
